import { render, staticRenderFns } from "./KfhcGmz.vue?vue&type=template&id=3244dd62&scoped=true&"
import script from "./KfhcGmz.vue?vue&type=script&lang=js&"
export * from "./KfhcGmz.vue?vue&type=script&lang=js&"
import style0 from "./KfhcGmz.vue?vue&type=style&index=0&id=3244dd62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3244dd62",
  null
  
)

export default component.exports